import { render, staticRenderFns } from "./MailingClick.vue?vue&type=template&id=3a509da6&"
import script from "./MailingClick.vue?vue&type=script&lang=ts&"
export * from "./MailingClick.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports